import api from "./api";

const fired = new Set();

export function track(event, meta = {}, once = false) {
  if (once) {
    if (fired.has(event)) return;
    fired.add(event);
  }
  api.post("/track", { event, meta }).catch(() => {});
}
